import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
    HomePage,
    DashboardPage,
    RolesPage,
    TablesPage,
    LogsPage
} from '../pages';

import { ApplicationRoles } from '../../helpers';

// Looking for an icon name?
// look here! https://material-ui.com/components/material-icons/
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import PeopleAltIcon from '@material-ui/icons/PeopleAltOutlined';
import LayersIcon from '@material-ui/icons/LayersOutlined';
import DescriptionIcon from '@material-ui/icons/Description';

export const NavRoutes = {

    Home: "/",
    Forbidden: "/forbidden",
    NotFound: "/notfound",
    Tables: "/tables",
    TableContent: "/tables/:tableId",
    DownloadExport: "/exports/download/:token",

    Admin: {
        Dashboard: "/admin",
        Roles: "/admin/roles",
        Role: "/admin/roles/:roleId",
        RoleUsers: "/admin/roles/:roleId/users",
        RoleUser: "/admin/roles/:roleId/users/:userId",
        Tables: "/admin/tables",
        Table: "/admin/tables/:tableId",
        TableUsers: "/admin/tables/:tableId/users",
        Logs: "/admin/logs",
    }
};

export const NavContext = React.createContext(null);

const { Provider } = NavContext;
export const NavProvider = ({ ...props }) => {
    const history = useHistory();

    const navigateTo = (route, args) => {
        route = compileRoute(route, args);
        history.push(route);
    }

    const switchTo = (route, args) => {
        route = compileRoute(route, args);
        history.replace(route);
    }

    const getRouteTo = (route, args) => {
        route = compileRoute(route, args);
        return route;
    }

    const goBack = () => {
        history.goBack();
    }

    const compileRoute = (route, args) => {
        if (route.includes(":") && args && args.length > 0) {
            for (let i = 0; i < args.length; i++) {
                let startIndex = route.indexOf(":", 0);
                if (startIndex === -1) break;
                let endIndex = route.indexOf("/", startIndex);
                if (endIndex === -1) endIndex = route.length - 1;
                else endIndex--;
                const token = route.substr(startIndex, (endIndex - startIndex) + 1);
                route = route.replace(token, args[i]);
            }
        }

        return route;
    }

    const getAllRoutes = (source) => {

        const getRoutes = (src, lst) => {
            const keys = Object.keys(src);
            for (let index in keys) {
                const key = keys[index];
                if (typeof src[key] === "string") {
                    lst.push(src[key]);
                } else {
                    getRoutes(src[key], lst);
                }
            }
        }

        const list = [];
        getRoutes(source, list);
        return list;
    }

    const [allRoutes, setAllRoutes] = useState(getAllRoutes(NavRoutes));

    const [menuItems, setMenuItems] = useState([
        {
            title: "Home",
            routePath: NavRoutes.Home,
            isProtected: true,
            component: HomePage,
            icon: <HomeOutlinedIcon />
        },
        {
            title: "Dashboard",
            routePath: NavRoutes.Admin.Dashboard,
            isProtected: true,
            component: DashboardPage,
            isAdmin: true
        },
        {
            title: "Roles",
            description: "View and manage user role assignations. Here you can monitor and handle user authorizations.",
            routePath: NavRoutes.Admin.Roles,
            icon: <PeopleAltIcon />,
            isProtected: true,
            component: RolesPage,
            isAdmin: true,
            roles: []
        },
        {
            title: "CRUD Tables",
            description: "View and manage tables. Here you can configure tables availability, grant access to editors and viewers.",
            routePath: NavRoutes.Admin.Tables,
            icon: <LayersIcon />,
            isProtected: true,
            component: TablesPage,
            isAdmin: true,
            roles: []
        },
        {
            title: "Logs",
            description: "View application logs. Here you can see trace of all CRUD operations and import operations done in a table.",
            routePath: NavRoutes.Admin.Logs,
            icon: <DescriptionIcon />,
            isProtected: true,
            component: LogsPage,
            isAdmin: true,
            roles: []
        },
    ]);

    return (
        <Provider value={{
            allRoutes,
            menuItems,
            navigateTo,
            switchTo,
            getRouteTo,
            goBack
        }}>
            {props.children}
        </Provider>
    );
}